import React from 'react';
import { useEffect, useState, useRef } from "react";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import moment from "moment";
import { format } from 'date-fns';
import '../../../common/rsuite-datepicker.css';
import Select from 'react-select';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import {
    setSelectedEmployee, getEmployeeAsync, updateIncludeDateRange, updateToReoladTimesheetApproval, updateApprovalAccountProjectId,
    updateAccountEmployeeIdFromApproval, updateTimesheetApprovalFilterDates
} from '../../timesheet/timesheetSlice';
import { useTranslation } from 'react-i18next';
import fetchAPI from '../../../common/fetchAPI';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource } from '../../../common/timeLiveFunction';
import DatePickerRanges from '../../../common/DatePickerRanges';

const TimesheetApprovalFilters = (props: any) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [isSearchable, setIsSearchable] = useState(true);
    // const [selectedOption, setSelectedOption] = useState<{ [object: string]: any }>();
    // const [employeeName, setEmployeeName] = useState<String | ''>('');
    // const [employeeArray, setEmployeeArray] = useState<any | ''>([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [employeeResponse, setemployeeResponse] = useState<any | ''>([]);
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');
    const { Employeesdata, employeeList, approvalAccountProjectId, accountEmployeeId, includeDateRange, timesheetApprovalStartDate, timesheetApprovalEndDate, timeEntryAccountEmployeeId } = useAppSelector((state) => state.timesheet);
    const { maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector((state) => state.globalState);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    // const [selectedEmployees, setSelectedEmployees] = useState(
    //     Employeesdata.filter((item: any) => item.isSelected === 1).map((item: any) => ({
    //         value: item.value,
    //         label: item.label,
    //     }))
    // );
    const [selectedEmployees, setSelectedEmployees] = useState(
    [
        {
            value: 0,
            label: "All"
        },
        ...Employeesdata
            .filter((item: any) => item.isSelected === 1)
            .map((item: any) => ({
                value: item.value,
                label: item.label,
            }))
    ]
);
    useEffect(() => {
        renderTimesheetFilter();
    }, []);

    useEffect(() => {
        renderEmployeeFilter();
    }, []);

    const renderTimesheetFilter = async () => {
        const response = await fetchAPI('api/V2/Projects/Assigned', 'Get', '', true);
        const json = await response.json();
        if (json.length > 0) {
            json.map((item: any) => {
                item.value = item.AccountProjectId;
                item.label = item.ProjectName;
            });
            json.unshift({ value: 0, label: 'All' });
            setProjectResponse(json);
        }
    }

    const renderEmployeeFilter = async () => {
        const response = await fetchAPI('api/Timesheets/GetAccountEmployeesForTimesheet/', 'Get', '', true);
        const json = await response.json();
        if (json.length > 0) {
            json.map((item: any) => {
                item.value = item.AccountEmployeeId;
                item.label = item.EmployeeName;
            });
            json.unshift({ value: 0, label: 'All' });
            setemployeeResponse(json);
        }
    }

    const onProjectChangeTrigger = (data: any) => {
        const { value, label } = data;
        dispatch(updateApprovalAccountProjectId(value));
    }

    const handleIncludeDateRange = (e: any) => {
        dispatch(updateIncludeDateRange(e.target.checked));
    }

    const onDropDownChange = (data: any) => {
        dispatch(updateAccountEmployeeIdFromApproval(data.value));
    }

    const handleDateRangeChange = (value: any) => {
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }        
        dispatch(updateTimesheetApprovalFilterDates({ "startDate": value[0], "endDate": value[1] }));
    }

    // const handleEmployeeOptionChange = (selectedOption: any) => {
    //     const values = selectedOption.map((option: any) => option.value);
    //     dispatch(setSelectedEmployee({ values }));
    //     dispatch(updateAccountEmployeeIdFromApproval(values));
    // }
    const handleEmployeeOptionChange = (selectedOption: any) => {
        let updatedOptions = selectedOption;
        const hasAll = selectedOption.some((option: any) => option.value === 0);
        if (hasAll && selectedOption.length > 1) {
            updatedOptions = selectedOption.filter((option: any) => option.value !== 0);
        }
        if (updatedOptions.length === 0) {
            updatedOptions = [
                {
                    value: 0,
                    label: "All"
                }
            ];
        }

    setSelectedEmployees(updatedOptions);

    const values = updatedOptions.map((option: any) => option.value);

    dispatch(setSelectedEmployee({ values }));
    dispatch(updateAccountEmployeeIdFromApproval(values));
};

    const handleApplyFilterOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
       
    }

    const handleResetFiltersOnClickEvent = () => {
        // dispatch(updateTimesheetApprovalFilterDates({"startDate": new Date(), "endDate": new Date()}))
        // setSelectedEmployees([]);
         resetFilters();
         
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
       
    }
    const resetFilters = () => {
        dispatch(updateTimesheetApprovalFilterDates({startDate: moment().startOf('year').toDate(),endDate: moment().endOf('year').toDate()}));
        // setSelectedEmployees([]);

        // dispatch(setSelectedEmployee({ values: [] }));
        setSelectedEmployees([
            {
                value: 0,
                label: "All"
            }
        ]);

        dispatch(setSelectedEmployee({
            values: [0]
        }));

        dispatch(updateAccountEmployeeIdFromApproval(0));
        dispatch(updateApprovalAccountProjectId(0));
        dispatch(updateIncludeDateRange(true));
        setDisplayedRange('Please Select Date Range');
         dispatch(updateToReoladTimesheetApproval(true));
    };
    
    return (
        <>
            <div className='card-body' style={{ overflowY: 'auto' }}>
                <div className='col-md-12'>
                    <label className="form-label fs-7 fw-normal mb-2">
                        {/* {t('Date Range')} */}
                        {getValueFromResource('Date Range',dispatch, t)}
                        </label>
                    <div>
                        <DateRangePicker
                            onChange={handleDateRangeChange}
                            ranges={DatePickerRanges() }
                            // value={[new Date(timesheetApprovalStartDate), new Date(timesheetApprovalEndDate)]}
                            value={[moment(timesheetApprovalStartDate).toDate(), moment(timesheetApprovalEndDate).toDate()]}
                            // placeholder={t('Please Select Date Range')}
                            placeholder={displayedRange}
                            character={' - '}
                            placement="bottomEnd"
                            cleanable={false}
                            format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                        ></DateRangePicker>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className="col-md-12">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name',dispatch, t)}
                            </label>
{/*                         <Select
                            value={Employeesdata.filter((x: any) => x.value == timeEntryAccountEmployeeId)}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={isSearchable}
                            name="employeeList"
                            onChange={(data) => onDropDownChange(data)}
                            //options={employeeResponse}
                            options={Employeesdata.map((item: any) => ({
                                value: item.value,
                                label: item.label,
                            }))}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        /> */}
                        <Select
                            placeholder=
                            // {t('Select')}
                            {getValueFromResource('Select',dispatch, t)}
                            isSearchable={true}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            isMulti
                            onChange={(selectedOption: any) => {
                                setSelectedEmployees(selectedOption); // Update local state on change
                                handleEmployeeOptionChange(selectedOption);
                            }}
                            value={selectedEmployees} // Bind to component value
                            options={Employeesdata.map((item: any) => ({
                                value: item.value,
                                label: item.label,
                            }))}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                        
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className="col-md-12">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Project Name')} */}
                            {getValueFromResource('Project Name',dispatch, t)}
                            </label>
                        <Select
                            value={projectResponse.filter((x: any) => x.value == approvalAccountProjectId)}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="projectList"
                            onChange={onProjectChangeTrigger}
                            options={projectResponse}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className="col-md-12">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Include Date Range')} */}
                            {getValueFromResource('Include Date Range',dispatch, t)}
                            </label>
                            <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input
                                 className="form-check-input h-20px w-30px"
                                type="checkbox" 
                                checked={includeDateRange}
                                onChange={(e) => { handleIncludeDateRange(e) }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className='card-footer pt-4'>
                <div className='d-flex flex-end'>
                    <a className={"btn btn-primary btn-sm"} onClick={() => dispatch(updateToReoladTimesheetApproval(true))}>
                        <i className="bi bi-filter fs-5 me-1"></i>{t('Apply Filters')}
                    </a>
                </div>
            </div> */}
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                            {/* {t('Apply Filter')} */}
                            {getValueFromResource('Apply Filter',dispatch, t)}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm me-2 fs-7"
                            data-kt-element='send'
                        onClick={handleResetFiltersOnClickEvent}
                        >
                            {/* {t('Reset Filters')} */}
                            {getValueFromResource('Reset Filters',dispatch, t)}
                        </button>
                        <button
                            type="button"
                            data-kt-element='send'
                            className="btn btn-primary btn-sm fs-7"
                        onClick={()=>{
                             dispatch(updateToReoladTimesheetApproval(true));
                             if (closeButtonRef.current) {
                                        closeButtonRef.current.click();
                                    }
                            }}
                        >
                            <i className="bi bi-filter fs-5 me-1"></i>
                            {/* {t('Apply Filters')} */}
                            {getValueFromResource('Apply Filters',dispatch, t)}
                        </button>
                    </div>
                </div>
            </div>
        </>

    )
}

export default TimesheetApprovalFilters;